<nav class="config-navbar navbar navbar-expand-lg w-100 bg-white border-bottom">
  <div class="container-fluid px-0 d-flex align-items-center gap-3 flex-nowrap">
    <button
      v-if="!hide_hamburger"
      class="btn d-flex d-lg-none align-items-center justify-content-center p-0 border-0 bg-transparent config-navbar-icon"
      @click="$emit('toggle-sidebar')"
      aria-label="Open menu"
    >
      <i class="bi bi-list fs-3"></i>
    </button>

    <div class="d-none d-xl-flex align-items-center gap-3 flex-grow-1 min-w-0">
      <div class="config-navbar-heading d-flex flex-column flex-shrink-0">
        <span class="config-navbar-eyebrow text-uppercase">{{ nav_section }}</span>
        <span class="config-navbar-title text-truncate">{{ nav_title }}</span>
      </div>

      <button
        type="button"
        class="config-search input-group flex-nowrap px-2 border-0 bg-transparent btn text-start"
        style="max-width: 460px;"
        @click="$emit('open-search-palette')"
      >
        <span class="input-group-text bg-transparent border-0 config-search-shortcut">
          <i class="bi bi-search text-secondary"></i>
        </span>
        <span class="form-control border-0 bg-transparent shadow-none text-start text-truncate config-search-placeholder">
          {{ search_placeholder }}
        </span>
        <span class="badge bg-white text-secondary border align-self-center config-search-shortcut">
          ⌘K
        </span>
      </button>

      <span class="config-live-pill d-inline-flex align-items-center gap-2 rounded-pill flex-shrink-0">
        <span class="config-live-dot rounded-circle"></span>
        <span>{{ live_status_label }}</span>
      </span>
    </div>

    <div class="ms-auto d-flex align-items-center gap-2 gap-lg-3 flex-shrink-0">
      <a
        href="#"
        class="config-navbar-icon d-none d-lg-inline-flex btn-link text-decoration-none align-items-center justify-content-center"
        aria-label="Notifications"
      >
        <i class="bi bi-bell fs-5"></i>
      </a>

      <a
        href="#"
        class="config-navbar-icon d-none d-lg-inline-flex btn-link text-decoration-none align-items-center justify-content-center"
        aria-label="Help"
      >
        <i class="bi bi-question-circle fs-5"></i>
      </a>

      <a
        href="#"
        class="config-navbar-action config-navbar-secondary-action d-none d-xl-inline-flex text-decoration-none align-items-center justify-content-center gap-2"
        aria-label="Open OnboardOS"
      >
        <i class="bi bi-box-arrow-up-right"></i>
        <span>Open OnboardOS</span>
      </a>

      <button
        type="button"
        class="config-navbar-action config-navbar-primary-action btn d-inline-flex align-items-center justify-content-center gap-2"
        @click="$emit('open-new-workflow-modal')"
      >
        <i class="bi bi-plus-lg"></i>
        <span>New workflow</span>
      </button>

      <button
        type="button"
        class="config-navbar-icon btn-link text-decoration-none d-inline-flex align-items-center justify-content-center"
        @click="sign_out"
        aria-label="Sign out"
        title="Sign out"
      >
        <i class="bi bi-box-arrow-right fs-5"></i>
      </button>

      <button
        type="button"
        class="config-ai-toggle-btn btn btn-outline-secondary d-none d-xl-inline-flex align-items-center justify-content-center gap-2"
        :class="show_ai_sidebar ? 'bg-light' : ''"
        @click="$emit('toggle-ai-sidebar')"
        :aria-pressed="show_ai_sidebar ? 'true' : 'false'"
        aria-label="Toggle AI sidebar"
      >
        <i class="bi bi-chat-dots-fill"></i>
        <span>AI</span>
      </button>

      <a
        href="#"
        class="config-navbar-user d-inline-flex align-items-center justify-content-center text-decoration-none flex-shrink-0"
        aria-label="User profile"
      >
        <span class="config-navbar-initials rounded-circle d-inline-flex align-items-center justify-content-center fw-bold">
          {{ user_initials || 'PN' }}
        </span>
      </a>
    </div>
  </div>
</nav>

<AiconeLogo />

